export function handle_google_admin_auth(identity_response: Record<string, string>) {
  const targetInput = document.querySelector("input[data-google-admin-target=credential]");
  if (targetInput && 'value' in targetInput) {
    targetInput.value = identity_response.credential;
  }

  const targetForm = document.querySelector("form[data-google-admin-target=auth-form]");
  if (targetForm) {
    (targetForm as HTMLFormElement).submit();
  }
}

declare global {
  interface Window {
    handle_google_admin_auth: (identity_response: Record<string, string>) => void;
  }
}
window.handle_google_admin_auth = handle_google_admin_auth;
